import {
  Html,
  Body,
  Container,
  Text,
  Heading,
  Section,
} from "@react-email/components";
import { Tailwind } from "@react-email/tailwind";

export default function ConsultationEmail({ values }) {
  return (
    <Html>
      <Tailwind>
        <Body className="bg-gray-100 py-6 font-sans">

          <Container className="max-w-md mx-auto bg-white rounded-xl overflow-hidden shadow">

            {/* HEADER */}
            <Section className="bg-[#FF5F00] text-center py-6">

              {/* Logo */}
              {/* <Img
                src="https://gdesk.vercel.app/logo.png"
                alt="GDesk Logo"
                className="mx-auto w-12 h-12 mb-2"
              /> */}

              {/* Brand Name */}
              <Heading className="text-white text-lg m-0">
                GDesk
              </Heading>

              <Text className="text-white text-xl mt-1 opacity-90">
                New Consultation Request
              </Text>

            </Section>

            {/* CONTENT */}
            <Section className="p-5">

              <Text className="text-xs text-gray-400 mb-1 mt-3">
                Full Name
              </Text>
              <Text className="text-sm text-gray-800 m-0">
                {values.firstName} {values.lastName}
              </Text>

              <Text className="text-xs text-gray-400 mb-1 mt-4">
                Email
              </Text>
              <Text className="text-sm text-gray-800 m-0">
                {values.email}
              </Text>

              <Text className="text-xs text-gray-400 mb-1 mt-4">
                Phone
              </Text>
              <Text className="text-sm text-gray-800 m-0">
                {values.phone || "Not provided"}
              </Text>

              <Text className="text-xs text-gray-400 mb-1 mt-4">
                Message
              </Text>
              <Text className="text-sm text-gray-800 bg-gray-50 p-3 rounded-lg whitespace-pre-line">
                {values.message || "No message provided"}
              </Text>

            </Section>

            {/* FOOTER */}
            <Text className="text-center text-xs text-gray-400 py-4">
              © {new Date().getFullYear()} GDesk. All rights reserved.
            </Text>

          </Container>

        </Body>
      </Tailwind>
    </Html>
  );
}